import {css} from '@emotion/react'
import ColorPicker from '@/components/Form/ColorPicker.jsx'

const cssPicker = css({
    aspectRatio: '1',
})

export default (table, columnKey) => {
    const {backgroundColor} = table.useColumnConfig(columnKey)

    const handleChange = backgroundColor => {
        table.setColumnConfig(columnKey, cfg => ({...cfg, backgroundColor}))
    }

    const suffix = (
        <ColorPicker
            css={cssPicker}
            value={backgroundColor}
            onChange={handleChange}
        />
    )

    return {
        key: 'column-bg-color',
        label: '背景色',
        suffix,
        onClick: e => e.preventDefault(),
    }
}
